import { _config } from 'Utilities/envConfig';
import log from 'Utilities/log';
export const notifyApp = (topic, data) => {
  var _window$ReactNativeWe;
  const message = JSON.stringify({
    topic,
    data
  });
  if (_config.environment !== 'production') {
    log.info(message);
  }
  (_window$ReactNativeWe = window.ReactNativeWebView) === null || _window$ReactNativeWe === void 0 || _window$ReactNativeWe.postMessage(message);
};